import type { FaireProductEntity } from "../../entity_types/product";

export const viverano_9: FaireProductEntity = {
  token: "viverano-9",
  type: "product",
  name: "Checkered - Terry Knit Sweater Knit Baby Blankets (Organic)",
  brandName: "Viverano Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/3d5266bb1551e522796cb0dce8cde4ec3f89c9c0f73665b1db5275b5b8477b8f.png?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=720&precrop=1760,1760,x127,y115,safe&width=720",
  priceDollars: 34.5,
  msrpDollars: 58,
  freeShipping: true,
  isBestseller: true,
  description: "",
  categoryTokens: ["cat_proto_nursery-decor"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
